import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { Apis, Labels } from '../../app.constants';
import { InvoiceProposalsAtom } from '../../../Services/_states';
import { errorAtom } from '../../../Services/_states/alert';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../../Services/APIService';

const DecisionBoardActions = () => {
  const [invoiceProposals, setInvoiceProposals] = useRecoilState(InvoiceProposalsAtom);

  const GetInvoiceProposals = async (data) => {
    let params = `?next_page=${data.pageNo}&search=${data.search}`;
    let res = await APIService.get(`${Apis.Get_Invoice_Proposals}${params}`);
    if (res.status == 200) return setInvoiceProposals(res.data);
  };

  const converCampaignToProposal = async (data) => {
    let res = await APIService.post(
      `v0/ui/website/${data.proposal.proposal_id}/convert-to-proposal/`,
      data.proposal
    );
    if (res.status == 200) {
      const list = invoiceProposals?.list;
      if (!Array.isArray(list)) {
        console.error('invoiceProposals.list is undefined or not an array');
        return;
      }
      let newList = list.map((item) => {
        if (item.proposal?.proposal_id === data.proposal?.proposal_id) {
          return {
            ...item,
            proposal: {
              ...item.proposal,
              campaign_state: 'PNC',
            },
          };
        }
        return item;
      });

      setInvoiceProposals({ ...invoiceProposals, list: newList });
    } else {
      console.log(res.data, 'error');
    }
  };

  const convertProposalToCampaign = async (data) => {
    let res = await APIService.post(
      `v0/ui/website/${data.proposal.proposal_id}/convert-to-campaign/`,
      data.proposal
    );
    if (res.status == 200) {
      let newList = invoiceProposals?.list?.map((item) => {
        if (item.proposal?.proposal_id === data.proposal?.proposal_id) {
          return {
            ...item,
            proposal: {
              ...item.proposal,
              campaign_state: 'PTC',
            },
          };
        }
        return item;
      });

      setInvoiceProposals({ ...invoiceProposals, list: newList });
    } else {
      console.log(res.data, 'error');
    }
  };

  const convertCampaignOnHold = async (data) => {
    data = {
      ...data,
      proposal: {
        ...data.proposal,
        campaign_state: 'POH',
      },
    };

    let res = await APIService.put(
      `v0/ui/website/proposal/${data.proposal.proposal_id}/`,
      data.proposal
    );
    if (res.status == 200) {
      const list = invoiceProposals?.list;
      if (!Array.isArray(list)) {
        console.error('invoiceProposals.list is undefined or not an array');
        return;
      }

      let newList = list.map((item) => {
        if (item.proposal?.proposal_id === data.proposal?.proposal_id) {
          return {
            ...item,
            proposal: {
              ...item.proposal,
              campaign_state: 'POH',
            },
          };
        }
        return item;
      });

      setInvoiceProposals({ ...invoiceProposals, list: newList });
    } else {
      console.log(Labels.Error, 'error');
    }
  };

  const getOrganisationList = async () => {
    let res = await APIService.get(`${Apis.getOrganisationsList}`);
    if (res.status == 200) {
      let newList = res.data.map(({ name: label, organisation_id: value, ...rest }) => ({
        label,
        value,
        ...rest,
      }));
      return newList;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getUserMinimalList = async (id) => {
    let res = await APIService.get(`${Apis.getUserMinimalList}?org_id=${id}`);
    if (res.status == 200) {
      let newList = res.data.map(({ username: label, id: value, ...rest }) => ({
        label,
        value,
        ...rest,
      }));
      return newList;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getProposalData = async (id) => {
    try {
      const res = await APIService.get(`v0/ui/website/proposal/${id}/`);
      if (res.status === 200) {
        console.log('success');
        return res;
      } else {
        console.log('Error fetching proposal');
        return null;
      }
    } catch (error) {
      console.error('API fetch error:', error);
      return null;
    }
  };

  const getTypeOFEndCustomer = async (id) => {
    try {
      const res = await APIService.get(`v0/ui/website/type-of-end-customer/`);
      if (res.status === 200) {
        console.log('success');
        return res;
      } else {
        console.log('Error fetching proposal');
        return null;
      }
    } catch (error) {
      console.error('API fetch error:', error);
      return null;
    }
  };

  const updateCampaignDesicionBoard = async (id, payload) => {
    try {
      const response = await APIService.put(`v0/ui/website/proposal/${id}/`, payload);
      if (response.status === 200) {
        console.log('success');
        return response;
      } else {
        console.log('Error update organisation');
        return null;
      }
    } catch (error) {
      console.error('Error updating organisation:', error);
      throw error;
    }
  };

  const CampaignAssignment = async (payload) => {
    try {
      const res = await APIService.post('v0/ui/website/campaign-assignment/', payload);
      if (res.status === 200) {
        return res;
      }
    } catch (error) {
      console.error('API error during campaign assignment:', error);
      return error;
    }
  };
  const CampaignUnAssignment = async (payload) => {
    try {
      const res = await APIService.post('/v0/ui/website/remove-assigned-campaign/', payload);
      if (res.status === 200) {
        return res;
      }
    } catch (error) {
      console.error('API error during campaign assignment:', error);
      return error;
    }
  };
  
  return {
    GetInvoiceProposals,
    converCampaignToProposal,
    convertProposalToCampaign,
    convertCampaignOnHold,
    getOrganisationList,
    getUserMinimalList,
    getProposalData,
    getTypeOFEndCustomer,
    updateCampaignDesicionBoard,
    CampaignAssignment,
    CampaignUnAssignment,
  };
};
export { DecisionBoardActions };
